import { Box, styled } from '@mui/material';
import { device } from '../../constants/devices';
import theme from '../../constants/theme';

const ResultsStyled = styled(Box)({
  '.result__wrapper': {
    cursor: 'pointer',
    padding: '20px 16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.secondary.dark}`,
    minHeight: '100px',
  },
  'ul.sui-results-container': {
    borderTop: `1px solid ${theme.palette.secondary.dark}`,
    marginBlockStart: '10px',
    marginBlockEnd: '10px',
  },
  [device.mobile]: {
    '.result__wrapper': {
      padding: '16px 0 !important',
    },
  },
});

export default ResultsStyled;
